/**
 * Shared layout tokens for « workbook » list pages (Cours-style).
 */

/** Compact pagination model: { type: 'page', page } | { type: 'ellipsis', key } */
export function paginationItems(currentPage, totalPages) {
  if (!totalPages || totalPages < 1) return [];
  if (totalPages <= 8) {
    return Array.from({ length: totalPages }, (_, i) => ({ type: 'page', page: i + 1 }));
  }
  const nodes = [{ type: 'page', page: 1 }];
  const left = Math.max(2, currentPage - 1);
  const right = Math.min(totalPages - 1, currentPage + 1);
  if (left > 2) nodes.push({ type: 'ellipsis', key: 'el-start' });
  for (let p = left; p <= right; p++) nodes.push({ type: 'page', page: p });
  if (right < totalPages - 1) nodes.push({ type: 'ellipsis', key: 'el-end' });
  nodes.push({ type: 'page', page: totalPages });
  return nodes;
}

export const FORMA_LINK_BTN =
  'inline-flex shrink-0 items-center gap-2 rounded-xl bg-forma-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-forma-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forma-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950';

/** Primary action button (forms, modals) — forma red, no purple gradient */
export const FORMA_PRIMARY_BTN =
  'inline-flex items-center justify-center gap-2 rounded-xl bg-forma-600 font-semibold text-white shadow-md transition hover:bg-forma-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forma-500 disabled:cursor-not-allowed disabled:opacity-70';

/** Compact filter dropdown used on list pages */
export const LIST_FILTER_SELECT_CLASS =
  'w-full min-w-[9rem] max-w-full appearance-none rounded-xl border border-slate-200 bg-white py-2.5 text-sm text-slate-900 shadow-sm focus:border-forma-500 focus:outline-none focus:ring-2 focus:ring-forma-500/25 dark:border-slate-600 dark:bg-slate-950 dark:text-slate-100 ltr:pl-3 ltr:pr-10 rtl:pl-10 rtl:pr-3';

/** Themed modal / drawer surfaces (matches UiCard) */
export const MODAL_OVERLAY =
  'fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm';

export const MODAL_SHELL =
  'rounded-2xl border border-slate-200 bg-white shadow-soft dark:border-slate-700 dark:bg-slate-900';

export const MODAL_INNER_PANEL =
  'rounded-xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800/50';

export const MODAL_TAB_ACTIVE =
  'border-b-2 border-forma-600 font-medium text-forma-700 dark:border-forma-400 dark:text-forma-300';

export const MODAL_TAB_INACTIVE =
  'font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800/50 dark:hover:text-slate-100';
